import { useMemo } from "react";

import { useHistory } from "react-router-dom";
import { AssetTypeCloudZero, type DataConnectorCloudZeroModel } from "@doitintl/cmp-models";
import { Button } from "@mui/material";
import { DateTime } from "luxon";

import { useCustomerContext } from "../../../Context/CustomerContext";
import CloudZeroAssetsTabHeader from "./components/cloudzero/CloudZeroAssetsTabHeader";
import CloudZeroAssetTable from "./components/cloudzero/CloudZeroAssetTable";
import NoAssets from "./components/NoAssets";

type Props = {
  cloudZeroConfigs: DataConnectorCloudZeroModel[];
};

const CloudZeroAssetsTab = ({ cloudZeroConfigs }: Props) => {
  const { customer } = useCustomerContext();
  const history = useHistory();

  const formattedCloudZeroConfigs = useMemo(
    () =>
      cloudZeroConfigs?.map((config) => ({
        ...config,
        timeCreated: DateTime.fromJSDate(config.timeCreated.toDate()),
      })),
    [cloudZeroConfigs]
  );

  const connectButton = useMemo(
    () => (
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          history.push(`/customers/${customer.id}/cloud-onboarding-cloudzero`);
        }}
        data-cy="cloudzero-connect-button"
      >
        Connect new account
      </Button>
    ),
    [customer.id, history]
  );

  if (!cloudZeroConfigs || cloudZeroConfigs.length === 0) {
    return <NoAssets assetType={AssetTypeCloudZero}>{connectButton}</NoAssets>;
  }

  return (
    <>
      <CloudZeroAssetsTabHeader />
      <CloudZeroAssetTable configs={formattedCloudZeroConfigs} />
    </>
  );
};

export default CloudZeroAssetsTab;
